import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Dashboard from "@/pages/Dashboard";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import MfaGate from "@/pages/MfaGate";
import SharedView from "@/pages/SharedView";
import SharedCommitteeSection from "@/pages/SharedCommitteeSection";
import DailyFlash from "@/pages/DailyFlash";
import { AuthProvider, useAuth } from "@/lib/auth";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#f8fafc] flex items-center justify-center text-[#475569] text-sm">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // MFA gate — if the user is enrolled but this session hasn't verified,
  // OR if the user has never enrolled, force them through the MFA setup/verify screen first.
  if (!user.mfa_verified) return <Navigate to="/mfa" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  // Detect the OAuth callback synchronously (before any effects/routes decide anything)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/shared/:token" element={<SharedView />} />
      <Route path="/shared/committee/:token" element={<SharedCommitteeSection />} />
      <Route
        path="/mfa"
        element={<MfaGate />}
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/day/:date"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/flash"
        element={
          <ProtectedRoute>
            <DailyFlash />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#ffffff",
            color: "#0f172a",
            border: "1px solid #e2e8f0",
          },
        }}
      />
    </div>
  );
}

export default App;
